var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#0048D4",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.4231 15.8077V14.8077H18.5769V15.8077H13.4231ZM13.4231 13.0384V12.0385H18.5769V13.0384H13.4231ZM11.8462 18.0385H17.1539C17.4574 18.0385 17.7379 18.1024 17.9954 18.2303C18.2529 18.3582 18.4719 18.5389 18.6524 18.7722L20.1539 20.7338V10.2367C20.1539 10.1677 20.1317 10.1109 20.0873 10.0666C20.0429 10.0222 19.9862 9.99998 19.9172 9.99998H12.0829C12.0138 9.99998 11.9571 10.0222 11.9128 10.0666C11.8684 10.1109 11.8462 10.1677 11.8462 10.2367V18.0385ZM12.0829 22H19.8595L17.8677 19.3866C17.7784 19.2689 17.6702 19.1815 17.5429 19.1243C17.4157 19.0671 17.286 19.0385 17.1539 19.0385H11.8462V21.7633C11.8462 21.8323 11.8684 21.8891 11.9128 21.9334C11.9571 21.9778 12.0138 22 12.0829 22ZM19.9164 23H12.0774C11.731 23 11.4391 22.8804 11.202 22.6413C10.9648 22.4022 10.8462 22.1096 10.8462 21.7633V10.2367C10.8462 9.89044 10.9658 9.59776 11.2051 9.35866C11.4443 9.11955 11.7372 9 12.0837 9H19.9226C20.2691 9 20.5609 9.11955 20.7981 9.35866C21.0353 9.59776 21.1539 9.89044 21.1539 10.2367V21.7633C21.1539 22.1096 21.0342 22.4022 20.795 22.6413C20.5557 22.8804 20.2629 23 19.9164 23Z",
    fill: "#0048D4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowIcon);
export default __webpack_public_path__ + "static/media/showIcon.f916eaa5a5916fce60173b1bc11dc4a5.svg";
export { ForwardRef as ReactComponent };